import client from "./client";

export const searchPlaces = async (q, lang) =>
  (await client.get("/geo/search", { params: { q, lang } })).data;

export const reverseGeocode = async (latitude, longitude, lang) =>
  (await client.get("/geo/reverse", { params: { latitude, longitude, lang } })).data;
